import React, { useState } from "react";
import { API } from '../config';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Gallery.css";

const Gallery = ({ items }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  // Helper to handle both Cloudinary and Local paths
  const getFullUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path; // Return Cloudinary URL as is
    return `${API}${path}`; // Append local backend for old paths
  };

  return (
    <div className="container my-4">
      <h2 className="text-center my-4 pt-5">View Gallery</h2>

      <div className="gallery">
        {items.map((item, index) => (
          <div key={index} className="gallery-item" onClick={() => setSelectedItem(item)}>
            {item.type === "image" ? (
              <img
                src={getFullUrl(item.src)}
                alt={`media-${index}`}
                className="img-fluid rounded shadow-sm"
              />
            ) : (
              <video
                src={getFullUrl(item.src)}
                muted loop playsInline autoPlay
                className="w-100 rounded shadow-sm"
              />
            )}
          </div>
        ))}
      </div>

      {/* Modal for Zoomed View */}
      {selectedItem && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,0.8)" }}
          onClick={() => setSelectedItem(null)}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content bg-transparent mx-auto p-0">
              <div className="modal-body text-center p-0">
                {selectedItem.type === "image" ? (
                  <img src={getFullUrl(selectedItem.src)} alt="zoomed" className="img-fluid rounded" />
                ) : (
                  <video src={getFullUrl(selectedItem.src)} controls autoPlay muted loop playsInline className="w-100 rounded" />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
